import { render, staticRenderFns } from "./DisabledAccount.vue?vue&type=template&id=449a8581&scoped=true"
import script from "./DisabledAccount.vue?vue&type=script&lang=js"
export * from "./DisabledAccount.vue?vue&type=script&lang=js"
import style0 from "./DisabledAccount.vue?vue&type=style&index=0&id=449a8581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a8581",
  null
  
)

export default component.exports